import axios from 'axios';
import Cookies from 'js-cookie';
import store from '../../store'

const standard = axios.create({
  baseURL: process.env.VUE_APP_API_HOST,
  timeout: 100000,
  withCredentials: true,
  transformResponse: [
    function (data) {
      return data;
    },
  ],
});

standard.interceptors.request.use(
  function (config) {
    if (config.url.includes('/api/payment')) {
      config.headers['Controller-Token-'] = store.state['controller-token-'];
      config.headers['RequestRay-Token-'] = store.state['requestray-token-'];
      config.headers['Firewall-Token-'] = store.state['firewall-token-'];
      config.headers['Cache-Token-'] = store.state['cache-token-'];
      config.headers['Trans-Token-'] = store.state['trans-token-'];
    }
    try{
      config.headers['Akamai-BM-Telemetry'] = bmak.get_telemetry();
    } catch (e) {
      console.log(e);
    }
    return config
  },
  function (error) {
    return Promise.reject(error);
  }
)



if (Cookies.get('access_token')) {
  standard.defaults.headers.common['Authorization'] = Cookies.get('access_token');
}

standard.defaults.headers.common['Access-Control-Allow-Origin'] = '*'





// standard.interceptors.response.use(..., ...)

export default standard;